var _path, _path2, _path3, _path4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7156 16.9736H8.49561C8.08161 16.9736 7.74561 16.6376 7.74561 16.2236C7.74561 15.8096 8.08161 15.4736 8.49561 15.4736H15.7156C16.1296 15.4736 16.4656 15.8096 16.4656 16.2236C16.4656 16.6376 16.1296 16.9736 15.7156 16.9736Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7156 12.7874H8.49561C8.08161 12.7874 7.74561 12.4514 7.74561 12.0374C7.74561 11.6234 8.08161 11.2874 8.49561 11.2874H15.7156C16.1296 11.2874 16.4656 11.6234 16.4656 12.0374C16.4656 12.4514 16.1296 12.7874 15.7156 12.7874Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2506 8.61035H8.49561C8.08161 8.61035 7.74561 8.27435 7.74561 7.86035C7.74561 7.44635 8.08161 7.11035 8.49561 7.11035H11.2506C11.6646 7.11035 12.0006 7.44635 12.0006 7.86035C12.0006 8.27435 11.6646 8.61035 11.2506 8.61035Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_67_1595",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 19,
    height: 20
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2.00024H21.1647V21.91H3V2.00024Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_67_1595)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9085 3.5L8.21951 3.504C5.89151 3.518 4.49951 4.958 4.49951 7.357V16.553C4.49951 18.968 5.90451 20.41 8.25551 20.41L15.9445 20.407C18.2725 20.393 19.6645 18.951 19.6645 16.553V7.357C19.6645 4.942 18.2605 3.5 15.9085 3.5ZM8.25651 21.91C5.11251 21.91 2.99951 19.757 2.99951 16.553V7.357C2.99951 4.124 5.04651 2.023 8.21451 2.004L15.9075 2H15.9085C19.0525 2 21.1645 4.153 21.1645 7.357V16.553C21.1645 19.785 19.1175 21.887 15.9495 21.907L8.25651 21.91Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/Document.bf0dd807ad23992c20ac0e34e46f4b4b.svg";
export { ForwardRef as ReactComponent };